import { initializeApp } from 'firebase/app'
import {
  getFirestore,
  Timestamp,
  GeoPoint,
  FieldValue,
  serverTimestamp,
  collection as _collection,
  getDoc as _getDoc,
  getDocs as _getDocs,
  updateDoc as _updateDoc,
  doc as _doc,
  onSnapshot as _onSnapshot,
  query as _query,
  where as _where,
  runTransaction as _runTransaction,
  QuerySnapshot,
  DocumentData,
  Query,
  Transaction,
  TransactionOptions,
  writeBatch,
  addDoc,
  setDoc,
  deleteDoc,
} from 'firebase/firestore'
import {
  getAuth,
  EmailAuthProvider,
  sendPasswordResetEmail as _sendPasswordResetEmail,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
} from 'firebase/auth'
import {
  getStorage,
  ref as storageRef,
  // TaskEvent,
  // TaskState,
  uploadBytesResumable as _uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from 'firebase/storage'
// import * as firebaseui from "firebaseui";

import { DocumentReference, UploadMetadata } from '@/firebase/types'
// export type UpdateData = UpdateData;
export type { UpdateData } from 'firebase/firestore'

import store from '@/store'

import firebaseConfig from '@root/firebase-config'

// init firebase app
const firebaseApp = initializeApp(firebaseConfig)

// get auth
const _auth = getAuth(firebaseApp)
export const AuthProvider = EmailAuthProvider
// export const authui = new firebaseui.auth.AuthUI(auth);
export const auth = {
  createUserWithEmailAndPassword: (email: string, password: string) =>
    createUserWithEmailAndPassword(_auth, email, password),
  signInWithEmailAndPassword: (email: string, password: string) =>
    signInWithEmailAndPassword(_auth, email, password),
  signOut: () => signOut(_auth),
  currentUser: () => _auth.currentUser,
  sendPasswordResetEmail: (email: string) =>
    _sendPasswordResetEmail(_auth, email),
}
// export const signin = () => authui.start('#firebaseui-auth-container', {
//   signInOptions: [
//     firebase.auth.EmailAuthProvider.PROVIDER_ID
//   ],
// });

// get firestore (db)
const _db = getFirestore(firebaseApp)
// export const query = (compositeFilter: QueryCompositeFilterConstraint, ...queryConstraints: QueryNonFilterConstraint[]) => _query(db, compositeFilter, ...queryConstraints)
export const db = {
  onCollectionSnapshot: (
    query: Query<DocumentData>,
    onSnapshot: (snapshot: QuerySnapshot<DocumentData>) => void
  ) => _onSnapshot(query, { next: onSnapshot }),
  collection: (path: string, ...pathSegments: string[]) =>
    _collection(_db, path, ...pathSegments),
  doc: (path: string, ...pathSegments: string[]) =>
    _doc(_db, path, ...pathSegments),
  newDoc: (path: string, ...pathSegments: string[]) =>
    _doc(_collection(_db, path, ...pathSegments)),
  addDoc: addDoc,
  setDoc: setDoc,
  deleteDoc: deleteDoc,
  // getDoc: (path: string, ...pathSegments: string[]) =>
  //   _getDoc(_doc(_db, path, ...pathSegments)),
  getDoc: _getDoc,
  getDocs: _getDocs,
  updateDoc: _updateDoc,
  runTransaction: <T>(
    fn: (transaction: Transaction) => Promise<T>,
    options?: TransactionOptions
  ) => _runTransaction(_db, fn, options),
  writeBatch: () => writeBatch(_db),
  query: _query,
  where: _where,
}

// handle auth login/logout
_auth.onAuthStateChanged((user) => {
  store.dispatch('SET_USER', user)

  if (!user) {
    // user is logged out
    // db.clearPersistence(); // https://stackoverflow.com/questions/61355151/firestore-how-to-clearpersistence
  }
})

// get storage
const _storage = getStorage(firebaseApp)
export const storage = {
  ref: (path: string) => storageRef(_storage, path),
  uploadBytesResumable: _uploadBytesResumable,
  getDownloadURL: getDownloadURL,
  delete: deleteObject,
}

// enable offline db
// db.enablePersistence().catch((err) => {
//   if (err.code == "failed-precondition") {
//     // Multiple tabs open, persistence can only be enabled
//     // in one tab at a a time.
//     console.error(err);
//   } else if (err.code == "unimplemented") {
//     // The current browser does not support all of the
//     // features required to enable persistence
//     console.error(err);
//   } else {
//     console.error(err);
//   }
// });

// Export types that exists in Firestore
// const { Timestamp, GeoPoint, FieldValue } = firebase.firestore;
// const { TaskEvent, TaskState } = firebase.storage;

// const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp;

export const firestoreTimestampToDate = (
  ts: Timestamp | null | undefined
): Date | undefined => (ts ? ts.toDate() : undefined)

export {
  // db,
  // auth,
  // storage,
  Timestamp,
  GeoPoint,
  FieldValue,
  DocumentReference,
  UploadMetadata,
  // TaskEvent,
  // TaskState,
  serverTimestamp,
}
